import { RefObject, useEffect, useRef } from "react";

export const useOutsideClick = (callback: any) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      } else {
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [ref]);

  return ref;
};

export type ShouldIgnoreClickFn = (event: MouseEvent) => boolean;

// alternative version with ref passed in
export const useClickOutside = (ref: RefObject<HTMLElement>, callback: () => void, shouldIgnoreClick?: ShouldIgnoreClickFn) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (shouldIgnoreClick?.(event)) {
          return;
        }
        // Check if the click is inside a Radix UI dropdown menu (which uses portals)
        const target = event.target as Node;
        if (target instanceof Element) {
          const dropdownMenu = target.closest('[role="menu"]');
          if (dropdownMenu) {
            return;
          }
        }
        callback();
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [ref, callback, shouldIgnoreClick]);
};
